import { createGlobalStyle } from 'styled-components';

// New color scheme based on design specifications
export const colors = {
  primaryDark: '#1A0C06', // Dark brown/black for header, footer, service sections
  accentOrange: '#F5A623', // Orange for CTAs, icons, headings
  lightBeige: '#F5F0E8', // Light beige for section backgrounds
  white: '#FFFFFF', // White for text on dark backgrounds
  textDark: '#000000', // Dark text on light backgrounds
  textGray: '#111111' // Dark gray text
};

const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
    }

    html {
        scroll-behavior: smooth;
    }

    body {
        background-color: ${colors.primaryDark};
        width: 100%;
        margin: 0px;
        padding: 0px;
        overflow-x: hidden;

        margin: 0;
        font-family: 'Montserrat', 'Roboto', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        line-height: 1.6;
    }
    
    code {
      font-family: 'Montserrat', 'Roboto', sans-serif;
    }

    h1, h2, h3, h4, h5, h6 {
        font-weight: 700;
        margin: 0 0 1rem 0;
    }

    p {
        margin: 0 0 1rem 0;
    }

    a {
        text-decoration: none;
        transition: color 0.3s ease;
    }

    button {
        cursor: pointer;
        border: none;
        font-family: inherit;
        font-weight: 600;
        transition: all 0.3s ease;
    }
`;

export default GlobalStyle;
